import axios, { AxiosRequestConfig } from 'axios';
import { DataResponse, PagedResponse } from '../types';

const URL = '/v2/admin/photo-moderation';

export interface PhotoModerationItem {
  id: number;
  userId: number;
  newPhotoHistoryId: number;
  newPhotoUrl: string | null;
  previousPhotoHistoryId: number | null;
  previousPhotoUrl: string | null;
  source: 'UPLOAD' | 'RENEWAL';
  priority: number;
  status: 'PENDING' | 'APPROVED' | 'REJECTED';
  moderatedBy: number | null;
  moderatedAt: string | null;
  created: string;
  userName: string | null;
}

export interface PhotoHistoryItem {
  id: number;
  userId: number;
  path: string;
  photoUrl: string | null;
  status: string;
  created: string;
  createdBy: number;
}

export interface PhotoModerationStats {
  pendingCount: number;
  reviewedTodayCount: number;
}

export type PhotoModerationAction = 'APPROVED' | 'REJECTED';

class PhotoModerationService {
  static getByFilter(config?: AxiosRequestConfig): Promise<PagedResponse<PhotoModerationItem>> {
    return axios.get(URL, config);
  }

  static getNext(config?: AxiosRequestConfig): Promise<DataResponse<PhotoModerationItem>> {
    return axios.get(`${URL}/next`, config);
  }

  static moderate(
    id: number,
    action: PhotoModerationAction,
    config?: AxiosRequestConfig
  ): Promise<DataResponse<PhotoModerationItem>> {
    return axios.patch(`${URL}/${id}/moderate`, { action }, config);
  }

  static getHistory(
    userId: number,
    config?: AxiosRequestConfig
  ): Promise<DataResponse<PhotoHistoryItem[]>> {
    return axios.get(`${URL}/history/${userId}`, config);
  }

  static getStats(config?: AxiosRequestConfig): Promise<DataResponse<PhotoModerationStats>> {
    return axios.get(`${URL}/stats`, config);
  }

  static backfill(config?: AxiosRequestConfig): Promise<DataResponse<number>> {
    return axios.post(`${URL}/backfill`, {}, config);
  }
}

export { PhotoModerationService };
